import ManageEmployees from 'modules/settings/management/manage-employees/components/ManageEmployees';
import ManageEmployeesWrapper from 'modules/settings/management/manage-employees/Main';

const ManageEmployeeesRoute = (): any => ({
  path: 'manage-employees',
  element: <ManageEmployeesWrapper />,
  children: [
    {
      path: '',
      element: <ManageEmployees />,
    },
  ],
});

export default ManageEmployeeesRoute;
